/* eslint-disable import/no-named-as-default-member */
import {FormControl, Select, Dialog, DialogTitle, DialogActions, DialogContent, IconButton, MenuItem, DatePicker } from "@material-ui/core";
import _ from "lodash";
import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import SimpleConfirmDialog from 'components/Global/ConfirmationDialogs/SimpleConfirmDialog';
import {
    ChildSectionTitle,
   } from '../FormSectionComponents';  
import OptionsMenu from "components/Global/OptionsMenu/OptionsMenu";
import amortizationTypes, {amortizationTypeList} from "constants/amortizationTypes";
import moment from "moment";
import { SecondaryButton, PrimaryButton } from "components/Global/Buttons";
import { VersitileInput } from "components/Global/Fields/VersitileInput";
import interestRateTypes from "constants/interestRateTypes";
import MaterialDatePicker from "material-ui-pickers/DatePicker";
import {updateExtensions, downloadExtensions} from "store/state/loan/loan";


const LB_BLUE = "#2196f3";

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding: 28px;
    min-height: 350px;
    overflow-x: hidden;
    overflow-y: auto;
  }
`;

const ModalTitle = styled.p`
  font-weight: normal;
  font-size: 17pt;
  margin-left: 20px;
`;

const PrettyTable = styled.table`
border-spacing: 0px;
`

const GreyHeader = styled.tr`
background-color: #f9f9f9;
color: black
`

const HeaderCell = styled.th`
&& {
    border-bottom: 3px solid #eeeeee;
    font-weight: normal;
    font-size: 19;
    width: 175px;
    text-align: left;
}
`

const UniformCell = styled.td`
&& {
    padding-top: 7px;
    padding-bottom: 7px;
    font-weight: normal;
    font-size: 19;
    width: 175px;
    text-align: left;
    border-bottom: 1px solid #ccc;
}`;

const GreyBox = styled.div `
  background-color: #eeeeee;
  color: #777777;
  border-radius: 3px;
  padding-top: 25px;
  padding-bottom: 25px;
  padding-left: 10px;
  font-size: 15px;
  vertical-align: middle;
  text-align: left;
  width: 900px
  margin-top: 10px;
  display: inline-block;
`;


class ExtensionsChildSection extends Component {

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        if(!this.props.formik) return null;
        if(this.getExtensions().length > 0 && !this.state.hasInitialSortBeenRun) {
            this.getExtensions().forEach(x=>this.calculateSortOrderOfExtension(x));
            this.props.formik.setFieldValue("extensions", _.orderBy(this.getExtensions(), "sortOrder", "asc"));
            this.setState({hasInitialSortBeenRun: true})
        }
    }

    state = {
        hasInitialSortBeenRun: false,
        isConfirmDeleteModalOpen: false,
        isMainExtensionModalOpen: false,
        extensionForDeletion: null,
        selectedExtension: null,
        isSelectedNew: false,
        recordBackup: null, //used to reset changes
    }


  getExtensions = () => {
      return this.props.formik.values.extensions || [];
  }

  addExtension = (extension) => {
    if(!extension.tempId){
        extension = {tempId: Math.floor(Math.random()*9999999), ...extension}
    }
    let newExtensions = this.getExtensions();
    newExtensions.push(extension);
    this.props.formik.setFieldValue("extensions", newExtensions);
    this.getExtensions().forEach(x=>this.calculateSortOrderOfExtension(x));
    return extension;
  }

  removeExtension = (extension) => {
        let idToDelete = extension.id || extension.tempId;
        let newExtensions = this.getExtensions();
        if(extension.id){
            newExtensions = this.getExtensions().filter(x=>x.id !== idToDelete);
        } else if (extension.tempId) {
            newExtensions = this.getExtensions().filter(x=>x.tempId !== idToDelete);
        }
        this.props.formik.setFieldValue("extensions", newExtensions);
  }

  calculateSortOrderOfExtension = (extension) => {
    let idToLookFor = extension.id || extension.tempId;
    let extensions = this.getExtensions();
    if(this.props.isQuote){
        extensions = _.orderBy(extensions,"sortOrder", "asc");
    } else {
        //sort using dateforSort field so it correctly sorts year then month then day
        extensions.forEach(x=>x.dateForSort = x.extensionStart ? moment.utc(x.extensionStart).format("YYYY-MM-DD") : null);
        extensions = _.orderBy(extensions,"dateForSort", "asc");
    }

    for(let i =0; i < extensions.length; i++) {
        let thisId = extensions[i].id || extensions[i].tempId;
        if(thisId === idToLookFor) {
            extension.sortOrder = i;
            return i;
        }
    }
  }

  openConfirmDeleteModal = (extension) => {
      this.setState({
          extensionForDeletion: extension,
          isConfirmDeleteModalOpen: true,
      });
    }

    closeConfirmDeleteModal = () => {
        this.setState({
            extensionForDeletion: null,
            isConfirmDeleteModalOpen: false,
        });
    }

    tellApiToHaveDbMatchFrontend = (extensions) => {
        //gives extensions to db and sets the extensions for this loan to match
        //may be used to both add or remove
        //500ms wait to allow state to finish updating
        setTimeout(()=>{ this.props.updateExtensions({loanId: this.props.formik.values.details.id, extensions: this.getExtensions()});}, 500);
    }

    isEffectivelyNull = (value) => {
        return value === null || value === undefined || value === "" || value == "NaN";
    }

    validateForm = () => {
        let isFloatingRateLoan = _.get(this.props,"formik.values.details.rateTypeId") == interestRateTypes.FLOATING;
        let record = this.state.selectedExtension;
        if(!record) return false;
        if(this.isEffectivelyNull(record.extensionFee) || Number.isNaN(record.extensionFee)) return false;
        if(this.props.isQuote) {
            if(this.isEffectivelyNull(record.extensionTerm) || Number.isNaN(record.extensionTerm)) return false;
        } else {
            if(this.isEffectivelyNull(record.extensionStart)) return false;
            if(this.isEffectivelyNull(record.extensionEnd)) return false;
        }
        if(this.isEffectivelyNull(record.extensionNoticeMin) || Number.isNaN(record.extensionNoticeMin) ) return false;
        if(this.isEffectivelyNull(record.extensionNoticeMax)|| Number.isNaN(record.extensionNoticeMax) ) return false;

        if(isFloatingRateLoan && record &&
            record.extensionAmortizationTypeId == amortizationTypes.MORTGAGE_STYLE){
                if(this.isEffectivelyNull(record.extensionAmortizationRate || Number.isNaN(record.extensionAmortizationRate))) {
                    return false
                }
        }
        if(record &&
            record.extensionAmortizationTypeId == amortizationTypes.MORTGAGE_STYLE){
                if(this.isEffectivelyNull(record.extensionAmortizationTerm) || Number.isNaN(record.extensionAmortizationTerm)){
                    return false
                }
            }
        if((record && (record.extensionAmortizationTypeId == amortizationTypes.STRAIGHT_LINE || 
            record.extensionAmortizationTypeId == amortizationTypes.STRAIGHT_LINE_CUSTOM_AMORT))){
                if(this.isEffectivelyNull(record.extensionAmortizationPrincipalReduction) || Number.isNaN(record.extensionAmortizationPrincipalReduction)){
                    return false
                }
            }
        return true;
    }

    calculateNewExtensionStart(extension) {
        let today = new Date();
        let orderedExtensions = this.getExtensions()
        if(orderedExtensions.length > 0) {
            return new Date(orderedExtensions[orderedExtensions.length-1].extensionEnd);
        } else if(!this.props.isQuote) {
            let maturity = _.get(this.props.formik, 'values.details.maturityDate');
            return maturity ? new Date(maturity) : today;
        }
        return today;
    }

    calculateNewExtensionEnd(extension) {
        let date = this.calculateNewExtensionStart(extension);
        date.setFullYear(date.getFullYear() + 1);
        return date;
    }


    openMainExtensionModal = (extension) => {
        if(extension) {
            this.setState({
                selectedExtension: extension,
                isMainExtensionModalOpen: true,
                recordBackup: _.cloneDeep(extension),
            })
        } else {
            this.setState({
                selectedExtension: this.addExtension({
                                        sortOrder: this.getExtensions().length, 
                                        extensionStart: this.calculateNewExtensionStart(),
                                        extensionEnd: this.calculateNewExtensionEnd()
                                    }),
                isMainExtensionModalOpen: true,
                isSelectedNew: true,
            })
        }
    }

    closeMainExtensionModal = () => {
        this.setState({
            isMainExtensionModalOpen: false,
            selectedExtension: null,
            isSelectedNew: false,
            recordBackup: null,
        })
    }

    calculateAndReturnDisplayNumberOfExtension = (extension) => {
        if(!extension) return "";
        let rawSortOrder = this.calculateSortOrderOfExtension(extension);
        let displayValue = rawSortOrder+1;
        let displayString = `${displayValue}`
        if(displayValue+1 === 11 || displayValue === 12 || displayValue === 13){
            displayString += "th";
        } else {
            switch (displayString.substring(displayString.length-1)){
                case '1' : displayString += "st"; break;
                case '2' : displayString += "nd"; break;
                case '3' : displayString += "rd"; break;
                default: displayString += "th"; break;
            }    
        }

        return displayString;
        
    }

    recalculateNoticeMinDate = (record) => {
        if(!record) return null;
        if(record.extensionNoticeMin!==null && record.extensionNoticeMin !== undefined && record.extensionStart) {
            let newDate = new Date(record.extensionStart);
            newDate.setDate((newDate.getDate() - record.extensionNoticeMin));
            this.updateExtension(record, "extensionNoticeMinDate", newDate);
        }
    }

    recalculateNoticeMaxDate = (record) => {
            if(!record) return null;
            if(record.extensionNoticeMax!==null && record.extensionNoticeMax !== undefined && record.extensionStart) {
                let newDate = new Date(record.extensionStart);
                newDate.setDate((newDate.getDate() - record.extensionNoticeMax));
                this.updateExtension(record, "extensionNoticeMaxDate", newDate);
            }
    }

    updateExtension(record, fieldName, value) {
        if(!record) return null;
        if(Number.isNaN(value)) value = null;
        let baseRecord = null;
        if(record.id) {
            baseRecord = this.getExtensions().filter(x=>x.id === record.id)[0];
        } else if(record.tempId){
            baseRecord = this.getExtensions().filter(x=>x.tempId === record.tempId)[0];
        }
        baseRecord[fieldName] = value;
        if(!baseRecord.tempId) baseRecord.tempId = Math.floor(Math.random() * 99999999);
        if(this.state.selectedExtension && (this.state.selectedExtension.tempId == baseRecord.tempId || this.state.selectedExtension.id == baseRecord.id)){
            this.setState({selectedExtension: baseRecord})
        }
        this.forceUpdate();
    }


  render() {
    const {isEditing, isQuote, formik} = this.props;
    let orderedExtensions = _.orderBy(this.getExtensions(),"sortOrder", "asc");
    return (
     <div id="loan_section_extension_terms">
          <ChildSectionTitle>Extensions</ChildSectionTitle>
          <PrettyTable>
                {this.renderHeader(isQuote)}
            {orderedExtensions.map(x=>this.renderRowForExtension(x))}
          </PrettyTable>
            {orderedExtensions.length==0 && <><GreyBox>No Extensions</GreyBox><br/></>}
          {isEditing && <SecondaryButton onClick={()=>{this.openMainExtensionModal(null)}}>+ Add Extension</SecondaryButton>}

          <SimpleConfirmDialog
          modalOpen={this.state.isConfirmDeleteModalOpen}
          title="Confirm Deletion"
          message={`You are about to delete an extension. This action cannot be undone. Are you sure you want to do this?`}
          yesText="Yes, Delete"
          noText="No"
          handleNo={this.closeConfirmDeleteModal}
          handleYes={()=>{
              this.removeExtension(this.state.extensionForDeletion);
              this.tellApiToHaveDbMatchFrontend(this.getExtensions());
              this.closeConfirmDeleteModal();
          }}
        />
        {this.renderMainExtensionModal()}
     </div>
    );
  }

  renderMainExtensionModal = () => {
    let isFloatingRateLoan = _.get(this.props,"formik.values.details.rateTypeId") == interestRateTypes.FLOATING;
    let isQuote = this.props.isQuote;
    let selectedExtension = this.state.selectedExtension;
    let inputStyle = {marginRight: "25px"};
    return (<Dialog open={this.state.isMainExtensionModalOpen}  maxWidth="md">
                <DialogTitle>
                    {this.calculateAndReturnDisplayNumberOfExtension(selectedExtension)} Extension <div style={{display:"inline-block", minWidth: "15px"}}></div>
                    {!this.validateForm() && <span style={{color:"red"}}>Required Fields Missing</span>}
                    </DialogTitle>
                    <StyledDialogContent style={{maxWidth: "md", minWidth: "700px"}}>
                        {isQuote && <div>
                            <VersitileInput  
                                value = {selectedExtension ? selectedExtension.extensionTerm : null}
                                type = "integer"
                                internalLabel = {"Extension Term (m)*"}
                                onChange = {value => {
                                    this.updateExtension(selectedExtension, "extensionTerm", value);
                                }}
                                style = {inputStyle}
                            />
                        </div>}
                        {!isQuote && <div>
                            <div style={{display: "inline-block"}}>
                                <span style={{fontSize: "16px", color: "#777777"}}>Start Date*</span>
                                <br/>
                                <MaterialDatePicker
                                    format = "MM/DD/YYYY"
                                    value = {selectedExtension ? selectedExtension.extensionStart : (this.calculateNewExtensionStart(selectedExtension)).setHours(0)} //setting hours helps avoid timezone issues
                                    style = {{width: "150px", backgroundColor: "white"}}
                                    onChange = { event => {
                                        this.updateExtension(selectedExtension, "extensionStart", event);
                                        this.recalculateNoticeMinDate(selectedExtension);
                                        this.recalculateNoticeMaxDate(selectedExtension);
                                        this.getExtensions().forEach(x=>this.calculateSortOrderOfExtension(x));
                                    }}
                                />
                            </div>
                            <div style={{display: "inline-block", marginLeft: "25px"}}>
                                <span style={{fontSize: "16px", color: "#777777"}}>End Date*</span>
                                <br/>
                                <MaterialDatePicker
                                    format = "MM/DD/YYYY"
                                    value = {selectedExtension ? selectedExtension.extensionEnd : (this.calculateNewExtensionEnd(selectedExtension)).setHours(0)}
                                    style = {{width: "150px", backgroundColor: "white"}}
                                    onChange = { event => {
                                        this.updateExtension(selectedExtension, "extensionEnd", event);
                                    }}
                                />
                            </div>
                        </div>}
                        <div style={{marginTop: "15px"}}>
                            <VersitileInput  
                            value = {selectedExtension ? selectedExtension.extensionNoticeMin : null}
                            type = "integer"
                            internalLabel = {"Notice Due Min (d)*"}
                            helperText = {isQuote ? "" : `Due by ${selectedExtension && selectedExtension.extensionNoticeMinDate ? moment.utc(selectedExtension.extensionNoticeMinDate).format("MM/DD/YYYY") : "-"}`}
                            onChange = {value => {
                                this.updateExtension(selectedExtension, "extensionNoticeMin", value);
                                this.recalculateNoticeMinDate(selectedExtension);
                            }}
                            style = {inputStyle}
                            />
                            <VersitileInput 
                            value = {selectedExtension ? selectedExtension.extensionNoticeMax : null}
                            type = "integer"
                            internalLabel = {"Notice Due Max (d)*"}
                            helperText = {isQuote ? "" : `Can Submit on ${selectedExtension && selectedExtension.extensionNoticeMaxDate ? moment.utc(selectedExtension.extensionNoticeMaxDate).format("MM/DD/YYYY") : "-"}`}
                            onChange = {value => {
                                this.updateExtension(selectedExtension, "extensionNoticeMax", value);
                                this.recalculateNoticeMaxDate(selectedExtension);
                            }}
                            style = {inputStyle}
                            />
                        </div>
                        <div style={{color: LB_BLUE, fontSize: "19px", marginTop: "15px" }}>
                            Minimum Qualifications
                        </div>
                        <div style={{marginTop: "15px"}}>
                            <VersitileInput 
                                value = {selectedExtension && selectedExtension.extensionLtv  ? selectedExtension.extensionLtv*100 : null}
                                type = "percent"
                                internalLabel = {"LTV"}
                                onChange = {value => {
                                    this.updateExtension(selectedExtension, "extensionLtv", (value/100).toFixed(4));
                                }}
                                style = {inputStyle}
                                />
                                 <VersitileInput 
                                value = {selectedExtension && selectedExtension.extensionDscr  ? selectedExtension.extensionDscr : null}
                                type = "dscr"
                                internalLabel = {"DSCR"}
                                onChange = {value => {
                                    this.updateExtension(selectedExtension, "extensionDscr", (value).toFixed(2));
                                }}
                                style = {inputStyle}
                                />
                                <VersitileInput 
                                value = {selectedExtension && selectedExtension.extensionDebtYield  ? selectedExtension.extensionDebtYield*100 : null}
                                type = "percentThreeDecimal"
                                internalLabel = {"Debt Yield"}
                                onChange = {value => {
                                    this.updateExtension(selectedExtension, "extensionDebtYield", (value/100).toFixed(5));
                                }}
                                style = {inputStyle}
                                />
                        </div>
                        <div style={{color: LB_BLUE, fontSize: "19px", marginTop: "15px" }}>
                            Amortization
                        </div>
                        <div style={{marginTop: "15px"}}>
                                <div style={{display: "inline-block", marginRight: "25px"}}>
                                    <span style={{fontSize: "16px", color: "#777777"}}>Amortization Type</span>
                                    <br/>
                                    <FormControl style={{minWidth: "150px"}}>
                                        <Select value= {selectedExtension ? selectedExtension.extensionAmortizationTypeId : null}
                                                onChange={e=>this.updateExtension(selectedExtension, "extensionAmortizationTypeId", e.target.value)}>
                                            {amortizationTypeList.map(x=><MenuItem value={x.value}>{x.name}</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </div>
                               {isFloatingRateLoan && selectedExtension &&
                               selectedExtension.extensionAmortizationTypeId == amortizationTypes.MORTGAGE_STYLE && 
                                    this.renderAmortRateInput(selectedExtension, inputStyle)}

                               {(selectedExtension && (selectedExtension.extensionAmortizationTypeId == amortizationTypes.MORTGAGE_STYLE || 
                               selectedExtension.extensionAmortizationTypeId == amortizationTypes.AGENCY_FLOATER)) &&
                                this.renderAmortTermInput(selectedExtension, inputStyle)}
                                
                                {(selectedExtension && (selectedExtension.extensionAmortizationTypeId == amortizationTypes.STRAIGHT_LINE || 
                               selectedExtension.extensionAmortizationTypeId == amortizationTypes.STRAIGHT_LINE_CUSTOM_AMORT)) &&
                                this.renderAmortPrincipleReductionInput(selectedExtension, inputStyle)}
                        </div>
                        <div style={{color: LB_BLUE, fontSize: "19px", marginTop: "15px" }}>
                            Fees and Misc
                        </div>
                        <div style={{marginTop: "15px"}}>
                            <VersitileInput 
                                value = {selectedExtension && selectedExtension.extensionFee  ? selectedExtension.extensionFee*100 : null}
                                type = "percentThreeDecimal"
                                internalLabel = {"Extension Fee*"}
                                onChange = {value => {
                                    this.updateExtension(selectedExtension, "extensionFee", (value/100).toFixed(5));
                                }}
                                style = {inputStyle}
                            />
                            
                            <VersitileInput 
                                value = {selectedExtension && selectedExtension.extensionQualifications  ? selectedExtension.extensionQualifications : null}
                                isMultiline = {true}
                                rows = {""}
                                internalLabel = {"Qualifications"}
                                onChange = {value => {
                                    this.updateExtension(selectedExtension, "extensionQualifications", value);
                                }}
                                style = {{marginRight:"25px", maxWidth: "450px", minWidth: "450px", }}
                            />
                        </div>
                        <div style={{color: LB_BLUE, fontSize: "19px", marginTop: "15px" }}>
                            Misc
                        </div>
                        <div style={{marginTop: "15px"}}>
                            <VersitileInput 
                                value = {selectedExtension && selectedExtension.extensionMisc  ? selectedExtension.extensionMisc : null}
                                isMultiline = {true}
                                rows = {""}
                                internalLabel = {"Misc"}
                                onChange = {value => {
                                    this.updateExtension(selectedExtension, "extensionMisc", value);
                                }}
                                style = {{marginRight:"25px", maxWidth: "650px", minWidth: "650px"}}
                            />
                        </div>
                    </StyledDialogContent>
                <DialogActions>
        <SecondaryButton onClick={()=>{
                if(this.state.isSelectedNew) {
                    this.removeExtension(selectedExtension);
                }
                if(this.state.recordBackup) {
                    //resest values on cancel
                    Object.keys(this.state.recordBackup).forEach(key => {
                        this.updateExtension(selectedExtension, key, this.state.recordBackup[key]);
                    });
                }
                this.closeMainExtensionModal();
            }}
        >{"Cancel"}</SecondaryButton>
            <PrimaryButton onClick={()=>{
                if(!this.validateForm()) return null;
                this.closeMainExtensionModal();
                this.tellApiToHaveDbMatchFrontend();
            }}>
            Save</PrimaryButton>
    </DialogActions>
    </Dialog>)
  }

  renderAmortRateInput = (selectedExtension, inputStyle) => {
    return (<VersitileInput 
        value = {selectedExtension && selectedExtension.extensionAmortizationRate  ? selectedExtension.extensionAmortizationRate*100 : null}
        type = "percentThreeDecimal"
        internalLabel = {"Amortization Rate"}
        onChange = {value => {
            this.updateExtension(selectedExtension, "extensionAmortizationRate", (value/100).toFixed(5));
        }}
        style = {inputStyle}
    />)
  }

  renderAmortTermInput = (selectedExtension, inputStyle) => {
   return ( <VersitileInput 
        value = {selectedExtension && selectedExtension.extensionAmortizationTerm  ? selectedExtension.extensionAmortizationTerm : null}
        type = "integer"
        internalLabel = {"Amortization Term"}
        onChange = {value => {
            this.updateExtension(selectedExtension, "extensionAmortizationTerm", (value));
        }}
        style = {inputStyle}
    />)
  }

  renderAmortPrincipleReductionInput = (selectedExtension, inputStyle) => {
      return (<VersitileInput 
        value = {selectedExtension && selectedExtension.extensionAmortizationPrincipalReduction  ? selectedExtension.extensionAmortizationPrincipalReduction : null}
        type = "money"
        internalLabel = {"Principle Redution"}
        onChange = {value => {
            this.updateExtension(selectedExtension, "extensionAmortizationPrincipalReduction", value);
        }}
        style = {inputStyle}
    />)
  }

  renderRowForExtension = (extension) => {
    let isQuote = this.props.isQuote;
    return (
        <tr>
            {isQuote &&
            <>
            <UniformCell style={{paddingLeft:"10px"}}>
                {extension.extensionTerm || "--"}
            </UniformCell>
            <UniformCell style={{paddingLeft:"10px"}}>
                {`${extension.extensionNoticeMin || ""} - ${extension.extensionNoticeMax || ""} days`}
            </UniformCell>
            </>
            }
            {!isQuote && <>
            <UniformCell style={{paddingLeft:"10px"}}>
                {extension.extensionStart ? moment.utc(extension.extensionStart).format("MMMM Do, YYYY") : "--"}
            </UniformCell>
            <UniformCell>
                {extension.extensionEnd ? moment.utc(extension.extensionEnd).format("MMMM Do, YYYY") : "--"}
            </UniformCell>
            <UniformCell>
                {extension.extensionNoticeMinDate ? moment.utc(extension.extensionNoticeMinDate).format("MMMM Do, YYYY") : "--"}
            </UniformCell>
            </>}
            <UniformCell>
                {extension.extensionFee ? `${(extension.extensionFee*100).toFixed(3)}%` : "--"}
            </UniformCell>
            <UniformCell style={{width: "200px"}}>
                {extension.extensionDscr && !this.isEffectivelyNull(extension.extensionDscr) ? `${extension.extensionDscr}x` : "--"}{` | `} 
                {extension.extensionLtv && !this.isEffectivelyNull(extension.extensionLtv) ? `${((extension.extensionLtv*100).toFixed(2))}%` : "--"}{` | `}
                {extension.extensionDebtYield && !this.isEffectivelyNull(extension.extensionDebtYield) ? `${(extension.extensionDebtYield*100).toFixed(2)}%` : "--"}
            </UniformCell>                 
            <UniformCell style={{textAlign: "right", paddingRight: "5px", width:"20px"}}>
                {this.props.isEditing && <OptionsMenu options={[
                            {
                                id:0,
                                value: 'Edit',
                                onClick: () => {this.openMainExtensionModal(extension)}
                            },
                            {
                                id:1,
                                value: 'Delete',
                                onClick: () => {this.openConfirmDeleteModal(extension)}
                            }
                        ]}/>}
            </UniformCell>

        </tr>
    )
  }

  renderHeader = (isQuote) => {
      if(isQuote){
          return (
            <GreyHeader>
                   <HeaderCell style={{paddingLeft: "10px"}}>
                        Extension term
                  </HeaderCell>
                  <HeaderCell>
                        Notice
                  </HeaderCell>
                  <HeaderCell>
                        Extension Fee
                  </HeaderCell>
                  <HeaderCell>
                        Min Qualifications
                  </HeaderCell>                 
                  <HeaderCell style={{textAlign: "right", paddingRight: "10px", width: "20px"}}>
                    <OptionsMenu options={[
                                {
                                    id:0,
                                    value: 'Export',
                                    onClick: () => {this.props.downloadExtensions({
                                        loanId: this.props.formik.values.details.id,
                                        extensions: this.getExtensions(),
                                        isQuote: this.props.isQuote})}
                                }
                            ]}/>
                  </HeaderCell>
              </GreyHeader>  
          )
      } else {
          return (
            <GreyHeader>
                  <HeaderCell style={{paddingLeft: "10px"}}>
                        Extension Start
                  </HeaderCell>
                  <HeaderCell>
                        Extension End
                  </HeaderCell>
                  <HeaderCell>
                        Notice Due
                  </HeaderCell>
                  <HeaderCell>
                        Extension Fee
                  </HeaderCell>
                  <HeaderCell>
                        Min Qualifications
                  </HeaderCell>                 
                  <HeaderCell style={{textAlign: "right", paddingRight: "10px", width: "20px"}}>
                        <OptionsMenu options={[
                            {
                                id:0,
                                value: 'Export',
                                onClick: () => {this.props.downloadExtensions({
                                    loanId: this.props.formik.values.details.id,
                                    extensions: this.getExtensions(),
                                    isQuote: this.props.isQuote})}
                            }
                        ]}/>
                  </HeaderCell>
              </GreyHeader>                
          )
      }
  }


}



function mapStateToProps({ authentication }) {
  return {
    authentication,
  };
}

export default compose(
  connect(mapStateToProps, {
    updateExtensions,
    downloadExtensions,
  })
)(ExtensionsChildSection);
